





































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  minLength,
  between,
  email,
  decimal,
  integer,
  url,
  sameAs,
  alphaNum,
} from 'vuelidate/lib/validators';
import VueSweetalert2 from 'vue-sweetalert2';
import { redirect, Routes } from '../shared/router';
import { client } from '../shared';
import { ForgotPwd } from '../shared/user';
@Component({
  components: {},
})
export default class ForgotPassword extends Vue {
  $v: any;
  form: any = {
    userName: null,
  };

  @Validations()
  validations: any = {
    form: {
      userName: { required },
    },
  };

  async submit() {
    try {
      const d = await client.post(
        new ForgotPwd({
          userName: this.form.userName,
        }),
      );
      this.$swal(
        'Password Reset',
        'Your usename has been emailed to you. If you need to reset your password, click the password reset link to complete the process. ',
        'success',
      ).then(() => {
        redirect(Routes.Home);
      });

    } catch (error) {
      this.$swal(
        'Password Reset',
        'Unable to locate the username or email address you provided. If you are not sure of the username or email address, you can always send an email to iidp-email@coh.org for assistance.',
        'error',
      ).then(() => {
          redirect(Routes.Home);
      });
      }
  }
}
